import { MapfreLabelComponent } from '../mapfre-label/mapfre-label.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup,  FormBuilder, FormsModule , ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbFormsModule, MapfreLabelComponent],
  selector: 'mapfre-input',
  templateUrl: './mapfre-input.component.html'
})
export class MapfreInputComponent{
  @Input() icon:                                boolean;
  @Input() isThisRequired:                      boolean;
  @Input() validation:                          boolean;
  @Input() additionalClasses:                   string;
  @Input() iconClasses:                         string;
  @Input() inputType:                           string;
  @Input() inputName:                           string;
  @Input() inputGroupControl;
  @Input() inputGroupControlType;
  @Input() group:                               FormGroup;
  
  @Output() inputValue: EventEmitter<string> = new EventEmitter();

  onInputOfValue(value: string){
    this.inputValue.emit(value);    
  }

  constructor(
    private fb: FormBuilder,
  ) {}


}
